import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import { useState } from 'react';
import {
  CANCELLATION_REASON_MAX_LENGTH,
  normalizeCancellationReason,
} from '@internal/spassu-code-contract';

function CancellationReasonField(props: {
  value: string;
  tooLong: boolean;
  onChange(next: string): void;
}) {
  return (
    <TextField
      // Material UI v4 does not generate an input id, so without this the label
      // has no `htmlFor` and the required field has no accessible name.
      id="cancel-activity-reason"
      label="Motivo do cancelamento"
      value={props.value}
      onChange={event => props.onChange(event.target.value)}
      error={props.tooLong}
      helperText={
        props.tooLong
          ? `O motivo aceita no máximo ${CANCELLATION_REASON_MAX_LENGTH} caracteres.`
          : 'Obrigatório. Fica registrado enquanto a atividade existir.'
      }
      multiline
      minRows={2}
      fullWidth
      inputProps={{ 'aria-required': true }}
    />
  );
}

/**
 * Cancellation always requires a reason, so the dialog is the only way to reach
 * it. Deliberately single-activity: ADR-004 makes cancellation an individual,
 * reasoned decision, never a batch action (UT-029).
 */
export function ControlPlaneCancelDialog(props: {
  open: boolean;
  activityTitle: string;
  busy: boolean;
  onClose(): void;
  onConfirm(reason: string): void;
}) {
  const [reason, setReason] = useState('');
  const normalized = normalizeCancellationReason(reason);
  const tooLong = reason.trim().length > CANCELLATION_REASON_MAX_LENGTH;
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="cancel-activity-title"
    >
      <DialogTitle id="cancel-activity-title">Cancelar atividade?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {`"${props.activityTitle}" ficará cancelada de forma definitiva. A conexão é
          revogada, novas execuções são bloqueadas e o workspace local é excluído.
          Cockpit, eventos e artefatos permanecem consultáveis.`}
        </DialogContentText>
        <CancellationReasonField
          value={reason}
          tooLong={tooLong}
          onChange={setReason}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} disabled={props.busy}>
          Voltar
        </Button>
        <Button
          color="secondary"
          variant="contained"
          disabled={props.busy || !normalized}
          onClick={() => {
            if (normalized) props.onConfirm(normalized);
          }}
        >
          Confirmar cancelamento
        </Button>
      </DialogActions>
    </Dialog>
  );
}
